import type { JSX } from 'react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

/**
 * Placeholder tab — Phase 9 ships the structural skeleton; the real
 * KPI summary arrives in Phase 17.
 */
export interface SiteKpiSummaryTabProps {
  readonly siteId: number;
}

export function SiteKpiSummaryTab({ siteId }: SiteKpiSummaryTabProps): JSX.Element {
  return (
    <Alert variant="default" data-testid="site-kpis-tab" data-site-id={siteId}>
      <AlertTitle>KPI summary</AlertTitle>
      <AlertDescription>
        Phase 17 — KPI rollups will populate this tab once the KPI engine ships.
      </AlertDescription>
    </Alert>
  );
}
